import {r as l} from '@theme/theme-sections';
import {F as d} from '@theme/flickity';
import '@theme/flickity-fade';
import '@theme/_commonjsHelpers';
const i = {
    sliderContainer: '[data-announcement-container]',
    slide: '[data-announcement]',
    closeButton: '[data-close-announcement-bar]',
  },
  n = {
    hide: 'hide',
    singleSlide: 'single-slide',
    selectedSlide: 'is-selected',
    hasAnnouncement: 'has-announcement-bar',
  },
  c = 'announcement-bar';
var o, a, r;
const u =
    ((r = (a = (o = window.Shopify) == null ? void 0 : o.theme) == null ? void 0 : a.sections) == null
      ? void 0
      : r.registered) || {},
  h = typeof u[c] > 'u';
h &&
  l(c, {
    onLoad() {
      const e = this.container;
      if (((this.showAnnouncement = !1), this.checkSessionStorage(), !this.showAnnouncement)) return;
      const t = e.querySelector(i.sliderContainer);
      if (t) {
        if ((e.classList.remove(n.hide), t.classList.contains(n.singleSlide))) {
          const s = e.querySelector(i.slide);
          s == null || s.classList.add(n.selectedSlide);
          return;
        }
        this.flickity = new d(t, {prevNextButtons: !1, autoPlay: 4500, pageDots: !1, adaptiveHeight: !0, fade: !0});
      }
    },
    checkSessionStorage() {
      sessionStorage.getItem('announcementBar') ||
        ((this.showAnnouncement = !0), document.body.classList.add(n.hasAnnouncement));
    },
    onBlockSelect(e) {
      if (!Shopify.designMode) return;
      this.settings.autoplay_speed > 0 && this.flickity.pausePlayer();
      const t = Array.from(e.target.parentElement.children).indexOf(e.target);
      this.flickity.select(t);
    },
    onDeselect() {
      Shopify.designMode && this.settings.autoplay_speed > 0 && this.flickity.unpausePlayer();
    },
  });
